import { Alert, Box, Card, CardContent, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { PropsWithChildren, ReactNode } from 'react';

export interface ILeftPanelProps {
  header: ReactNode;
  list: ReactNode;
}

export function LeftPanel(props: ILeftPanelProps) {
  return (
    <Grid size={4} display='flex' flexDirection={'column'} height='100%'>
      <Box>{props.header}</Box>
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <Box sx={{ flex: 1, overflow: 'auto', paddingBottom: '1rem' }}>{props.list}</Box>
      </Box>
    </Grid>
  );
}

export interface IRightPanelProps extends PropsWithChildren {
  selectedItemCount: number;
  topMessage: string | ReactNode;
}

export function RightPanel(props: IRightPanelProps) {
  const { selectedItemCount, topMessage } = props;
  return (
    <Grid size={8} display={'flex'} height={'100%'} flex={1} width={'100%'}>
      <Card
        sx={{
          backgroundColor: 'white',
          flexDirection: 'column',
          flex: 1,
          height: '100%',
          overflow: 'hidden',
        }}
        variant={'outlined'}
      >
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          }}
        >
          {selectedItemCount > 1 ? (
            <Alert severity='info' sx={{ mb: 2 }}>
              {topMessage}
            </Alert>
          ) : (
            <Typography variant='body1' gutterBottom>
              {topMessage}
            </Typography>
          )}
          {selectedItemCount > 0 && (
            <Box display={'flex'} overflow={'auto'} flex={1}>
              {props.children}
            </Box>
          )}
        </CardContent>
      </Card>
    </Grid>
  );
}
